import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/store/pinia/auth'
import { ModalContent, ModalHeader } from '@/v2/components/ui/modal'
import LogosMap from '../logos/LogosMap.vue'
import AppIcon from '../ui/icon/AppIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CertifiedViaSupport',
  emits: ["click:back"],
  setup(__props, { emit }) {

const authStore = useAuthStore()



function openWhatsapp() {
  const message = `Olá me chamo ${authStore.session!.user.name}, estou na plataforma Bioplanner e preciso de ajuda.`

  const link = `https://api.whatsapp.com/send?phone=5511998933332&text=${message}&lang=pt_br`
  window.open(link, '_blank')
}

return { __sfc: true,authStore, emit, openWhatsapp, ModalContent, ModalHeader, LogosMap, AppIcon }
}

})